import { Grid } from '@farewill/ui'

import InputFloating from 'components/form/input-floating'
import { Address as AddressType } from 'lib/models/address'

import Address from './address'

type Props = {
  address: AddressType | null
  handleSave: (event: { name: string; value: string | number | null }) => void
  onUnsavedAddressChange?: (address: AddressType) => void
}

const ContactDetailsFields = ({
  address,
  handleSave,
  onUnsavedAddressChange,
}: Props) => (
  <>
    <Grid.Item span={12}>
      <Address
        label="Address"
        name="address"
        data={address}
        onUnsavedChange={onUnsavedAddressChange}
      />
    </Grid.Item>
    <Grid.Item span={12}>
      <InputFloating name="email" label="Email" handleSave={handleSave} />
    </Grid.Item>
    <Grid.Item span={12}>
      <InputFloating
        name="phoneNumber"
        label="Phone number"
        handleSave={handleSave}
      />
    </Grid.Item>
  </>
)

export default ContactDetailsFields
